<template>
    <div v-if="h5ConfigData.image" class="answer-portrait" :style="{ 'background-image': `url(${h5ConfigData.image})` }"></div>
    <div v-else>
        <div class="answer-sjtu" v-if="owner">
            <img :src="myurl" alt="sjtu" />
        </div>
        <div class="answer-portrait" v-else>
            <img :src="portrait" alt="portrait" />
        </div>
    </div>
</template>

<script>
import { domain } from '../../Service/api'

export default {
  props: {
    h5ConfigData: {
      type: Object
    },
    owner: String
  },
  data () {
    return {
      myurl: `https://oss.${domain}/ms-system/ecardServer/beta/gallery/1000001318-9e16d1ead6204757b449fda2f11c7f06.png`,
      portrait: `https://oss.talkinggenie.com/ms-system/ecardServer/test/gallery/1000002541-a678fd153d2c49d09110686aa892cbe4.png`
    }
  }
}
</script>

<style lang="scss" scoped>
.answer-portrait {
    margin-right: 20px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background: linear-gradient(135deg, rgba(48, 35, 174, 1) 0%, rgba(200, 109, 215, 1) 100%) no-repeat center center / cover;
    .iconfont {
        color: #ffffff;
        font-size: 32px; /*px*/
    }
}
.answer-sjtu {
    margin-right: 20px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    img {
        width: 100%;
    }
}
.answer-portrait {
    margin-right: 20px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    img {
        width: 100%;
        background-color: #ffffff;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/AnswerPortrait.vue